import {useLayoutQuery} from '../page-data/loaders/use-layout-query'

export function usePullRequestState() {
  const {
    data: {
      pullRequest: {state},
    },
  } = useLayoutQuery()

  return state
}
